import React from 'react';
import { Card, CardMedia, CardContent, Typography, CardActions, Button, Rating } from '@mui/material';
import { Favorite, FavoriteBorder } from '@mui/icons-material';
import { Game } from '../../types/game';
import styles from './GameCard.module.css';

interface GameCardProps {
  game: Game;
  isFavorite: boolean;
  onFavoriteToggle: (game: Game) => void;
  onClick: () => void;
}

const GameCard: React.FC<GameCardProps> = ({ game, isFavorite, onFavoriteToggle, onClick }) => {
  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onFavoriteToggle(game);
  };

  return (
    <Card className={styles.card} onClick={onClick}>
      <CardMedia
        className={styles.media}
        image={game.thumbnail}
        title={game.title}
      />
      <CardContent className={styles.content}>
        <Typography gutterBottom variant="h5" component="h2" className={styles.title}>
          {game.title}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p" className={styles.genre}>
          {game.genre} • {game.platform}
        </Typography>
        <Typography variant="body2" component="p" className={styles.description}>
          {game.short_description}
        </Typography>
      </CardContent>
      <CardActions className={styles.footer}>
        <Rating value={game.rating || 4} readOnly size="small" />
        <Button
          size="small"
          color="primary"
          onClick={handleFavoriteClick}
          startIcon={isFavorite ? <Favorite /> : <FavoriteBorder />}
        >
          {isFavorite ? 'В избранном' : 'В избранное'}
        </Button>
      </CardActions>
    </Card>
  );
};

export default GameCard;